import React from 'react';
import { Box, Typography } from '@mui/material';
import playButtonImage from '../../assets/Play.png';
import { useRobloxPlayerCount } from '../../hooks';

const ROBLOX_PLACE_ID = 12599929830;
const ROBLOX_PLAY_URL = `https://www.roblox.com/games/${ROBLOX_PLACE_ID}/Mako-Magic-2-Roleplay`;

const getPlayerCountMessage = (playing: number): string => {
    if (playing <= 0) {
        return 'Be the first Mermaid in the current game!';
    }
    if (playing === 1) {
        return 'Join 1 other Mermaid in the current game!';
    }
    return `Join ${playing.toLocaleString()} other Mermaids in the current game!`;
};

const PlayButton: React.FC = () => {
    const playing = useRobloxPlayerCount(ROBLOX_PLACE_ID);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                mb: 2,
            }}
        >
            <Box
                component="a"
                href={ROBLOX_PLAY_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Play Mako Magic 2 Roleplay on Roblox"
                sx={{
                    display: 'block',
                    width: { xs: 80, sm: 120, md: 180 },
                    maxWidth: '90vw',
                    transition: 'transform 0.3s ease, filter 0.3s ease',
                    filter: 'drop-shadow(0 6px 16px rgba(0, 0, 0, 0.45))',
                    '&:hover': {
                        transform: 'scale(1.08)',
                        filter: [
                            'drop-shadow(0 0 20px rgba(255, 152, 0, 0.9))',
                            'drop-shadow(0 0 40px rgba(255, 120, 0, 0.55))',
                            'drop-shadow(0 10px 24px rgba(0, 0, 0, 0.55))',
                        ].join(' '),
                    },
                }}
            >
                <Box
                    component="img"
                    src={playButtonImage}
                    alt="Play"
                    sx={{
                        width: '100%',
                        height: 'auto',
                        display: 'block',
                    }}
                />
            </Box>
            {playing !== null && (
                <Typography
                    variant="body2"
                    sx={{
                        mt: 1.5,
                        textAlign: 'center',
                        fontWeight: 600,
                        fontSize: { xs: '0.85rem', sm: '0.95rem' },
                        color: '#e8f5e9',
                        textShadow: '0 2px 8px rgba(0, 0, 0, 0.6)',
                        px: 2,
                    }}
                >
                    {getPlayerCountMessage(playing)}
                </Typography>
            )}
        </Box>
    );
};

export default PlayButton;
